export default __webpack_public_path__ + "static/media/consumeheart.316d6ce6.png";